import { useEffect } from 'react';
import { toast } from 'react-toastify';

const useUpdateCreateAlert = (status, message) => {
  useEffect(() => {
    if (status === 'updated') {
      toast.success(`${message}`);
    } else if (status === 'created') {
      toast.success(`${message}`);
    }else if (status === 'error') {
      toast.error(message);
    }else if(status!= undefined){
      toast.success(`${status}: ${message}`);
    }
  }, [status, message]);
};

export default useUpdateCreateAlert;